import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from 'types';


export const widgetURL = 'https://zienyai.com/ai-widget.js';
// export const widgetPreviewURL = 'http://localhost:3300';
export const widgetPreviewURL = 'https://preview.ar-view-zieny.com';
//const apiBaseUrl = 'https://api-app.ar-view-zieny.com';
 const apiBaseUrl = 'https://api-saas.zieny.ai';
// const apiBaseUrl = 'http://localhost:3100';

const baseUrl = apiBaseUrl + '/api';

const imageBaseUrl = 'https://zieny-media-data.s3.eu-central-1.amazonaws.com';

const defaultHeaders = {
	Accept: 'application/json',
};

const prepareHeaders = (headers: any, { getState }) => {
	const token = (getState() as RootState)?.global?.user?.api_token;
	if (token) {
		headers.set('Authorization', `Bearer ${token}`);
	}
	return headers;
};

const baseQueryOriginal = fetchBaseQuery({
	baseUrl,
	headers: defaultHeaders,
	prepareHeaders,
});

// Custom base query wrapper to handle 401 responses
export const baseQuery = async (args, api, extraOptions) => {
	const result = await baseQueryOriginal(args, api, extraOptions);

	// Handle 401 Unauthorized responses
	if (result.error?.status === 401) {
		// Clear authentication state
		const state = api.getState() as RootState;
		if (state.global?.user) {
			// Dispatch logout action to clear Redux state and localStorage
			api.dispatch({ type: 'global/logout' });
		}

		// Redirect to login page
		window.location.href = '/login';
	}

	return result;
};

export const formatErrors = (response: any) => {
	const errors = response.data || response;
	let message: string[] = [];
	if (errors?.messages) {
		message = errors?.messages || ['Something went wrong'];
	} else if (errors?.errors) {
		message = errors?.errors || ['Something went wrong'];
	}

	if (message.length === 0) {
		const subError = errors.data;
		if (Array.isArray(subError?.messages)) {
			message = subError?.messages;
		} else if (Array.isArray(subError?.errors)) {
			message = subError?.errors;
		} else if (subError?.message) {
			message = [subError?.message];
		}
	}

	if (message.length === 0) {
		message = ['Something went wrong'];
	}
	return {
		message: message,
		status: errors?.status,
		statusText: errors?.statusText,
		errors: errors?.errors,
		meta: errors?.meta,
		rawError: errors,
	};
};

export const transformPaginatedResponse = data => data?.response;

export const HTTP_METHODS = {
	GET: 'GET',
	POST: 'POST',
	PUT: 'PUT',
	DELETE: 'DELETE',
	PATCH: 'PATCH',
};

export const endpoints = {
	baseUrl,
	imageBaseUrl,
	sendOtp: {
		url: `/send-otp`,
		method: HTTP_METHODS.POST,
	},
	// Authentication endpoints
	login: {
		url: `/auth/login`,
		method: HTTP_METHODS.POST,
	},
	forgotPassword: {
		url: `/auth/forgot-password`,
		method: HTTP_METHODS.POST,
	},
	resetPassword: {
		url: `/auth/reset-password`,
		method: HTTP_METHODS.POST,
	},
	// Profile endpoints
	getProfile: {
		url: `/profile`,
		method: HTTP_METHODS.GET,
	},
	updateProfile: {
		url: `/profile`,
		method: HTTP_METHODS.PUT,
	},
	updateWebsiteSettings: {
		url: `/profile/website-settings`,
		method: HTTP_METHODS.PUT,
	},
	getUserTimezone: {
		url: `/profile/timezone`,
		method: HTTP_METHODS.GET,
	},
	// Template Setting endpoints
	getWidgetTemplate: {
		url: `/widget-template`,
		method: HTTP_METHODS.GET,
	},
	saveWidgetTemplate: {
		url: `/widget-template`,
		method: HTTP_METHODS.POST,
	},
	generateARButtonCode: {
		url: `/generate-ar-code`,
		method: HTTP_METHODS.POST,
	},
	// AR Settings endpoints
	getARSettings: {
		url: `/ar-settings`,
		method: HTTP_METHODS.GET,
	},
	saveARIntegration: {
		url: `/ar-settings/integration`,
		method: HTTP_METHODS.POST,
	},
	updateARFonts: {
		url: `/ar-settings/fonts`,
		method: HTTP_METHODS.POST,
	},
	createARTranslations: {
		url: `/ar-settings/translations`,
		method: HTTP_METHODS.POST,
	},
	// Employee management endpoints
	getEmployees: {
		url: `/employees`,
		method: HTTP_METHODS.GET,
	},
	getUsersByCompany: {
		url: `/users/company/:companyId`,
		method: HTTP_METHODS.GET,
	},
	inviteEmployee: {
		url: `/users/invite`,
		method: HTTP_METHODS.POST,
	},
	deleteUser: {
		url: `/users/:id`,
		method: HTTP_METHODS.DELETE,
	},
	updateEmployeeRole: {
		url: `/users/:id/role`,
		method: HTTP_METHODS.PUT,
	},
	// Product management endpoints
	getProducts: {
		url: `/products`,
		method: HTTP_METHODS.GET,
	},
	getProductById: {
		url: `/products/:id`,
		method: HTTP_METHODS.GET,
	},
	createProduct: {
		url: `/products`,
		method: HTTP_METHODS.POST,
	},
	updateProduct: {
		url: `/products/:id`,
		method: HTTP_METHODS.PUT,
	},
	deleteProduct: {
		url: `/products/:id`,
		method: HTTP_METHODS.DELETE,
	},
	bulkDeleteProducts: {
		url: `/products/bulk-delete`,
		method: HTTP_METHODS.DELETE,
	},
	updateProductStock: {
		url: `/products/:id/stock`,
		method: HTTP_METHODS.PATCH,
	},
	uploadProductImages: {
		url: `/products/:id/images`,
		method: HTTP_METHODS.POST,
	},
	uploadProduct3DModel: {
		url: `/products/:id/model`,
		method: HTTP_METHODS.POST,
	},
	getProductStats: {
		url: `/products/stats`,
		method: HTTP_METHODS.GET,
	},
	importProductCsv: {
		url: `/products/import-csv`,
		method: HTTP_METHODS.POST,
	},
	importProductUrl: {
		url: '/products/import-url',
		method: HTTP_METHODS.POST,
	},
	getImportStatus: {
		url: `/products/import/status`,
		method: HTTP_METHODS.GET,
	},
	getFailedUrls: {
		url: `/products/url-import/failed`,
		method: HTTP_METHODS.GET,
	},
	getLowStockProducts: {
		url: `/products/low-stock`,
		method: HTTP_METHODS.GET,
	},
	exportProductsCsv: {
		url: `/products/export-csv`,
		method: HTTP_METHODS.GET,
	},
	genericUpload: {
		url: `/upload`,
		method: HTTP_METHODS.POST,
	},
	updateCompany: {
		url: `/companies/:id`,
		method: HTTP_METHODS.PUT,
	},
	getCompany: {
		url: `/companies/:id`,
		method: HTTP_METHODS.GET,
	},
	getCompanyUserProfile: {
		url: `companies/user/profile`,
		method: HTTP_METHODS.GET,
	},
	updateCompanyUserProfile: {
		url: `/companies/user/profile`,
		method: HTTP_METHODS.PUT,
	},
	companyUserChangePassword: {
		url: "/companies/user/change-password",
		method: HTTP_METHODS.POST,
	},
	// Dashboard endpoints
	dashboard: {
		stats: {
			url: `/dashboard/stats`,
			method: HTTP_METHODS.GET,
		},
		attentionItems: {
			url: `/dashboard/attention-items`,
			method: HTTP_METHODS.GET,
		},
		recentActivity: {
			url: `/dashboard/recent-activity`,
			method: HTTP_METHODS.GET,
		},
		analyticsMetrics: {
			url: `/dashboard/analytics-metrics`,
			method: HTTP_METHODS.GET,
		},
		topProducts: {
			url: `/dashboard/top-products`,
			method: HTTP_METHODS.GET,
		},
		exportCsv: {
			url: `/dashboard/export-csv`,
			method: HTTP_METHODS.GET,
		},
		resetDailyCredits: {
			url: `/dashboard/reset-daily-credits`,
			method: HTTP_METHODS.POST,
		},
	},
	analytics: {
		stats: {
			url: `/dashboard`,
			method: HTTP_METHODS.GET,
		},
	},
	// Translation management endpoints
	translations: {
		list: {
			url: `/translations`,
			method: HTTP_METHODS.GET,
		},
		create: {
			url: `/translations`,
			method: HTTP_METHODS.POST,
		},
		getById: {
			url: `/translations/:id`,
			method: HTTP_METHODS.GET,
		},
		update: {
			url: `/translations/:id`,
			method: HTTP_METHODS.PUT,
		},
		delete: {
			url: `/translations/:id`,
			method: HTTP_METHODS.DELETE,
		},
		getByCompany: {
			url: `/translations/company/:companyId`,
			method: HTTP_METHODS.GET,
		},
	},
	xmlFeed: {
		getFeed: {
			url: `/xml-feed`,
			method: HTTP_METHODS.GET,
		},
		fetchSchema: {
			url: `/xml-feed/fetch-schema`,
			method: HTTP_METHODS.POST,
		},
		connect: {
			url: `/xml-feed/connect`,
			method: HTTP_METHODS.POST,
		},
		updateMapping: {
			url: `/xml-feed/mapping`,
			method: HTTP_METHODS.PUT,
		},
		forceSync: {
			url: `/xml-feed/sync`,
			method: HTTP_METHODS.POST,
		},
		disconnect: {
			url: `/xml-feed`,
			method: HTTP_METHODS.DELETE,
		},
	},
	renderLogs: {
		url: `/render-logs`,
		method: HTTP_METHODS.GET,
	},
};
